<script lang="ts" setup>
import Language from '@@/enums/Language'

const { user } = useAuthStore()
const { updateLanguage } = useLanguage()
</script>

<template>
  <form v-if="user">
    <fieldset class="settings-language">
      <CommonTypography
        variant="h4"
        component="h2"
      >
        {{ $t('settings.language') }}
      </CommonTypography>
      <ModusRadioGroupRoot
        :default-value="user.preferredLanguage"
        @update:model-value="updateLanguage"
      >
        <ModusRadioGroupButton
          :value="Language.NB"
          :label="$t('language.nb')"
        />

        <ModusRadioGroupButton
          :value="Language.NN"
          :label="$t('language.nn')"
        />
      </ModusRadioGroupRoot>
    </fieldset>
  </form>
</template>

<style lang="scss" scoped>
  fieldset {
    all: unset;
  }

  .settings-language {
    display: flex;
    flex-direction: column;
    gap: .6em;
  }

  .flex {
    display: flex;
    align-items: center;
  }
</style>
